<template>
  <div class="main reg-page page-inside">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">MY BALANCE</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <section class="section page-body-section topup-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div class="container">
            <div class="form">
              <div class="form-wrapper">
                <div class="form-fields register-content">
                  <div class="title">{{ $t("TOP UP") }}</div>
                  <div class="form-fields-wrapper">
                    <label>
                      <div class="desc" :placeholder="$t('First name')">
                        {{ $t("First name") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('First name')"
                        v-model="name"
                      />
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('Last Name')">
                        {{ $t("Last Name") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Last Name')"
                        v-model="surname"
                      />
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('Email')">
                        {{ $t("Email") }}:
                      </div>
                      <input
                        type="email"
                        :placeholder="$t('Email')"
                        v-model="email"
                      />
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('Phone')">
                        {{ $t("Phone") }}:
                      </div>
                      <input
                        type="number"
                        :placeholder="$t('Phone')"
                        v-model="phone"
                      />
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('Address')">
                        {{ $t("Address") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Address')"
                        v-model="address"
                      />
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('City')">
                        {{ $t("City") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('City')"
                        v-model="city"
                      />
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('Country')">
                        {{ $t("Country") }}:
                      </div>
                      <select v-model="country">
                        <option v-for="item in countryOptions" :key="item.id">
                          {{ $t(item.title) }}
                        </option>
                      </select>
                    </label>
                    <label>
                      <div class="desc" :placeholder="$t('Zip Code')">
                        {{ $t("Zip Code") }}:
                      </div>
                      <input
                        type="text"
                        :placeholder="$t('Zip Code')"
                        v-model="zipCode"
                      />
                    </label>
                    <div class="desc desc-32 topup-amount">
                      {{ topUpAmount }}
                      <img src="./../images/coin2.svg" class="coin" />
                      =
                      <span>
                        {{ (topUpAmount * $parent.currencyRate).toFixed(2) }}
                        {{ currency }}</span
                      >
                    </div>
                    <div class="cta-container">
                      <div class="chekbox-container">
                        <label class="chekbox-label">
                          <div class="chekbox-label-wrapper">
                            <input
                              type="checkbox"
                              name="terms"
                              v-model="terms"
                            />
                            <div class="checkbox"></div>
                            <span class="desc">{{ $t("I agree with") }} </span>
                            <a @click="$parent.goToPrivacy()" class="desc">
                              {{ $t("privacy policy") }}</a
                            >
                            <span class="desc"> {{ $t("and") }} </span>
                            <a @click="$parent.goToTerms()" class="desc">
                              {{ $t("terms and conditions") }}</a
                            >
                          </div>
                        </label>
                      </div>
                      <div class="button-container multi">
                        <button
                          v-for="method in paymentMethods"
                          :key="method.id"
                          :class="[
                            'button action',
                            { disabled: !requiredFieldsAreFilled },
                          ]"
                          @click="submit(method.id)"
                        >
                          <img
                            v-if="methodImage(method)"
                            :src="methodImage(method)"
                            :alt="methodTitle(method)"
                          />
                          <span v-else>{{ methodTitle(method) }}</span>
                        </button>
                      </div>
                    </div>
                    <transition name="slide">
                      <div v-if="$parent.error" class="error-desc desc red">
                        {{ $parent.error }}
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Registration",
  props: ["currency"],
  components: {},
  data: function () {
    return {
      email: "",
      name: "",
      phone: "",
      surname: "",
      nickname: "",
      country: "",
      countryId: "",
      countryOptions: "",
      city: "",
      address: "",
      zipCode: "",
      terms: false,
      topUpAmount: "",
    };
  },

  watch: {
    currency: function () {
      if (this.currency) {
        this.getCurr();
      }
    },
    country: function () {
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.country === this.countryOptions[i].title) {
          this.countryId = this.countryOptions[i].id;
          break;
        }
      }
      this.countryId;
    },
  },
  mounted() {
    this.getCounties();
    this.setTopUpAmount();
    if (this.currency) {
      this.getCurr();
    }
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.countryId &&
        this.city &&
        this.address &&
        this.zipCode &&
        this.terms &&
        this.email
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
    paymentMethods() {
      const settings = this.$parent.settings;
      return (settings && settings.payment_methods) || [];
    },
  },
  methods: {
    methodImage(method) {
      return method.image || method.logo || method.icon || "";
    },
    methodTitle(method) {
      return method.title || method.name || "";
    },
    submit(paymentMethodId) {
      let data = {
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        email: this.email,
        country: this.countryId,
        city: this.city,
        address: this.address,
        postCode: this.zipCode,
        amount: this.topUpAmount,
        payment_method_id: paymentMethodId,
        currency: this.$parent.currency,
      };
      this.$emit("topupSubmit", data);
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch(() => {});
    },
    getCurr() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile?currency=" + this.currency)
        .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.email = res.data.email;
          this.nickname = res.data.nickname;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    setTopUpAmount() {
      this.topUpAmount = this.$parent.topUpAmount;
    },
  },
};
</script>
